// @ts-check
import {
  SET_ACTIVE_TAB,
  SET_FORM_OPEN,
  SET_FORM_QUERY_SENT,
  MAIN_VIEW_CLICKED
} from '../redux/actions/actionTypes'

const initialState = {
  active_tab: 0,
  form_open: true,
  plooto_queries_count: 0
}

export function topLevelReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        active_tab: action.payload
      }
    case SET_FORM_OPEN:
      return {
        ...state,
        form_open: action.payload
      }
    case MAIN_VIEW_CLICKED:
      return {
        ...state,
        form_open: false
      }
    case SET_FORM_QUERY_SENT:
      return {
        ...state,
        plooto_queries_count: state.plooto_queries_count + 1
      }

    default:
      return state
  }
}